import type { Component } from "solid-js";
import {
  ProfileLayoutMainContentContainer,
  ProfileSidebarLayout,
} from "@/components/layout/ProfileLayout";
import { ApplicationsTab } from "@/domains/freelance/profile/components/tabbed-version/tabs/ApplicationsTab";

export const FreelancerApplicationsRoute: Component = () => {
  return (
    <ProfileSidebarLayout>
      <ProfileLayoutMainContentContainer>
        <ApplicationsTab />
      </ProfileLayoutMainContentContainer>
    </ProfileSidebarLayout>
  );
};
